export default __webpack_public_path__ + "static/img/repli_seller_portal.4a6ceef.png";